type SubTableProps = {
  children: React.ReactNode;
};

const SubTable = ({ children }: SubTableProps) => {
  return (
    <tr className="subTable__row">
      <td colSpan={100}>
        <div className="subTable__container">
          <div className="subTable__table">{children}</div>
        </div>
      </td>
    </tr>
  );
};

export default SubTable;
